import tabs from "../demo/tabs.js";

let tabs_extended = tabs;

tabs_extended.address.examples = ["москва астоженка 12", "Москва Пятницкая 3"];
tabs_extended.name.examples = ["Илля Ильич Обломов", "Иван Перрович Семенов"];
tabs_extended.phone.examples = ["7(926)) 723-12-23", "8800 555-35-23"];
tabs_extended.email.examples = ["ivan@gmail.com ", "info@dadata.ru"];
tabs_extended.passport.examples = ["6503 234457", "2503 135457"];
tabs_extended.vehicle.examples = ["ФордФокус", "Киа рио"];

export default tabs_extended;
